import { useGlobalEmergencyCall } from '../hooks/useGlobalEmergencyCall'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Button, EmergencyCallFilledIcon } from '@hivewatch/dark'

import { MixpanelDataIProps } from '@/features/incident-drawer'

import { DarkGlobalEmergencyCallModal } from './DarkGlobalEmergencyCallModal'

interface DarkGlobalEmergencyCallButtonIProps {
  mixpanelData?: MixpanelDataIProps
}

/**
 * Rebrand re-skin of {@link GlobalEmergencyCallButton} using the dark package
 * `Button` (danger variant). Shares the emergency-call flow via
 * {@link useGlobalEmergencyCall}. Must be rendered within a `DarkProvider`.
 */
export const DarkGlobalEmergencyCallButton = ({
  mixpanelData,
}: DarkGlobalEmergencyCallButtonIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const {
    isOpen,
    onClose,
    isLoading,
    emergencyCallCategoryId,
    handleEmergencyButtonClick,
    handleCallClick,
  } = useGlobalEmergencyCall(mixpanelData)

  return (
    <>
      <Button
        colorScheme={colorScheme}
        data-testid='GlobalEmergencyCall:button'
        isLoading={isLoading}
        onClick={handleEmergencyButtonClick}
        rightIcon={<EmergencyCallFilledIcon size={18} />}
        size='lg'
        variant='danger'
      >
        {t('emergency_call:emergency')}
      </Button>
      {isOpen && (
        <DarkGlobalEmergencyCallModal
          emergencyCallCategoryId={emergencyCallCategoryId}
          handleOnClick={handleCallClick}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </>
  )
}
